import { z } from "zod";

/*
 * The Bison folders the message index reads (LEA-311, LEA-314), in one place: the Bison client's
 * listing, the `message_index` job resource, the reader's cadence and the progress rows all derive
 * from this list. Browser-safe: the job panel reads the job resource schema.
 */

export const INDEX_FOLDERS = ["bounced", "inbox", "spam"] as const;
export const IndexFolderSchema = z.enum(INDEX_FOLDERS);
export type IndexFolder = z.infer<typeof IndexFolderSchema>;
